module.exports = __webpack_public_path__ + "img/disc-fill.78f450b5.svg";